import React, { useMemo, useState } from 'react';
import Icon from './Icon';

// Görevler sayfasının solundaki marka paneli (ClickUp'taki klasör ağacı gibi).
// value: null (tümü) | 'none' (markasız) | hesap id'si. Sayılar açık (tamamlanmamış) görevlerdir.
export default function BrandSidebar({ accounts, tasks, userId, value, onChange }) {
  const [q, setQ] = useState('');
  const [showEmpty, setShowEmpty] = useState(false);

  const { counts, noneCount, total } = useMemo(() => {
    const c = new Map();
    let none = 0, all = 0;
    tasks.forEach(t => {
      if (t.status === 'done') return;
      all++;
      if (t.account_id) c.set(t.account_id, (c.get(t.account_id) || 0) + 1);
      else none++;
    });
    return { counts: c, noneCount: none, total: all };
  }, [tasks]);

  const norm = (s) => String(s || '').toLocaleLowerCase('tr');
  const match = (a) => !q || norm(a.name).includes(norm(q));
  const mine = accounts.filter(a => (a.am_id === userId || a.ppc_id === userId) && match(a));
  const others = accounts.filter(a => a.am_id !== userId && a.ppc_id !== userId && match(a));
  const withTasks = others.filter(a => counts.get(a.id)).sort((a, b) => counts.get(b.id) - counts.get(a.id) || a.name.localeCompare(b.name, 'tr'));
  const empty = others.filter(a => !counts.get(a.id));

  const item = (key, label, n, active, extra) => (
    <button key={key} type="button" className={`bs-item ${active ? 'is-on' : ''} ${!n ? 'is-empty' : ''}`} onClick={() => onChange(key)} title={label}>
      <span className="bs-item__name">{label}</span>
      {extra}
      {n > 0 && <span className="bs-item__count">{n}</span>}
    </button>
  );

  return (
    <aside className="bs">
      <div className="bs-search">
        <Icon name="search" size={13} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Marka ara" />
      </div>
      {item(null, 'Tüm markalar', total, value == null)}
      {item('none', 'Markasız (iç iş)', noneCount, value === 'none')}

      {mine.length > 0 && <div className="bs-title">Benim markalarım</div>}
      {mine.map(a => item(a.id, a.name, counts.get(a.id) || 0, value === a.id))}

      {withTasks.length > 0 && <div className="bs-title">{mine.length ? 'Diğer markalar' : 'Markalar'}</div>}
      {withTasks.map(a => item(a.id, a.name, counts.get(a.id) || 0, value === a.id))}

      {empty.length > 0 && (
        <>
          <button type="button" className="bs-more" onClick={() => setShowEmpty(s => !s)}>
            <Icon name={showEmpty || q ? 'chevronDown' : 'chevronRight'} size={12} /> Açık görevi olmayanlar ({empty.length})
          </button>
          {(showEmpty || q) && empty.map(a => item(a.id, a.name, 0, value === a.id))}
        </>
      )}
    </aside>
  );
}
